module.exports = __webpack_public_path__ + "asset/image-Percent-40d9114d8da361d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Percent.svg
// module id = mYgp
// module chunks = 0